import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { WorksheetService } from '../../../@core/data/worksheets/worksheet.service';
import { CookieService } from "ngx-cookie-service";
import * as moment from 'moment';
import { capitalizeFirstLetter } from "../../../helpers/string-helper";
import { tinyMceDefaultConfiguration } from "../../../helpers/tiny-mce";
import { Store } from "@ngrx/store";
import { IAppState } from "../../../store/app.state";
import {
  getConta3Users,
  getTeamByUserId, getTeamLeads,
  getTeams, getUserTeamLeader, isJuridic,
  isUserConta3,
  isUserTeamLead,
} from "../../../store/teams/teams.selectors";
import { combineLatest, Subject } from "rxjs";
import {
  getJuridicUsers,
  getLoggedUser,
  getUsers,
  getUsersThatCanSolveAllTickets
} from "../../../store/users/users.selectors";
import { ConfirmActionModalComponent } from "../../clients/confirm-action-modal/confirm-action-modal.component";
import { DomSanitizer } from '@angular/platform-browser';
const _ = require('lodash');
import { ToastrConfigs } from '../../../@core/data/toastr-config';
import { acceptedChatFileTypes } from '../../../shared/utils';
import { takeUntil } from 'rxjs/operators';
import { WorksheetTicketSeverityLabel } from '../../../@core/data/worksheets/worksheet.service';

@Component({
  selector: 'ngx-conta-tickets-form',
  templateUrl: 'conta-tickets-form.component.html',
  styleUrls: ['conta-tickets-form.component.scss']
})
export class ContaTicketsFormComponent implements OnInit {
  @ViewChild('editorElement', {static: false}) editorElement: ElementRef;
  @ViewChild('chatForm', {read: ElementRef}) chatForm: ElementRef;

  @Input() ticketObj;
  @Input() openToRespond: boolean;

  public formGroup: FormGroup;
  isSpinnerActive: boolean = false;
  userId: string;
  coordinatorId: string;
  isPageLoaded = false;
  capitalizeFirstLetter = capitalizeFirstLetter;
  protected readonly moment = moment;
  userName: string;
  teams = [];
  editorSettings = tinyMceDefaultConfiguration;
  ticketSolver = [];
  messages: any[] = [];
  files = [];
  ticket;
  user;
  subject = new Subject<void>();
  departments = ['CONTABILITATE', 'HR', 'IT', 'JURIDIC', 'FONDURI EU'];
  isTicketCreated = false;
  severityLabels = WorksheetTicketSeverityLabel;
  constructor(
    protected ref: NbDialogRef<ContaTicketsFormComponent>,
    private cookieService: CookieService,
    private worksheetService: WorksheetService,
    private store: Store<IAppState>,
    private dialogService: NbDialogService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private toastrService: NbToastrService 
  ) {
    this.formGroup = new FormGroup({});
    this.userId = localStorage.getItem('userId') || this.cookieService.get('UserId');
    this.userName = localStorage.getItem('adminUserName') || this.cookieService.get('UserId');
  }

  ngOnInit() {
    this.store.select(getLoggedUser).pipe(takeUntil(this.subject)).subscribe((user) => { 
      if (!user?.user_id) return;
      this.user = { ...user };
    });
    this.getTicket();
  }

  ngOnDestroy () {
    this.subject.next();
  }

  dismiss(data: any) {
    this.ref.close(data);
  }

  sendMessage(event: any) {
    this.formGroup.controls['severity'].markAsTouched();
    this.formGroup.controls['title'].markAsTouched();
    this.formGroup.controls['toUserId'].markAsTouched();
  
    if (this.formGroup.controls['severity'].invalid || this.formGroup.controls['title'].invalid || this.formGroup.controls['toUserId'].invalid) {
      const message = event.message;
      setTimeout(() => {
        const textarea = this.chatForm?.nativeElement?.querySelector('textarea');
        if (textarea) {
          textarea.value = message;
          textarea.dispatchEvent(new Event('input'));
        }
      });
      return;
    }

    const files = event.files;
  
    if (files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => {
        const fileContent = reader.result.toString().split(',')[1]; 
        this.sendChatToTicket(event, files, fileContent);
      };
      reader.readAsDataURL(files?.[0]);
    } else {
      this.sendChatToTicket(event, null, '');
    }
    this.focusChatInput();
  }
  
  addMessage(message: string, fileName: string, files: any[], originalFileName: string = "") {
    this.messages.push({
      text: message,
      date: new Date(),
      message: `${message} ${originalFileName || fileName}`,
      reply: true,
      type: files?.length > 0 ? 'asconFile' : 'text',
      files: files,
      user: {
        name: `${this.user?.user_firstname} ${this.user?.user_lastname}`,
        avatar: '',
      },
      fileName: fileName,
    });
  }

  sendChatToTicket(event: any, files: any[], fileContent: string | null, notifyClient: boolean = true) {
    const formValues = this.formGroup?.getRawValue();
    const existingId = this.ticket?.id || formValues?.id;
    const ticket = {
        ...this.ticket,
        ...formValues,
        id: existingId,
        category: formValues?.department,
    };

    if (!existingId) {
        ticket.issue = event.message;
    }

    const originalName = files?.[0].name;
    const originalType = files?.[0].type;
     if (originalName && !acceptedChatFileTypes.includes(originalType)) {
      this.toastrService.show('Format de document invalid', 'Eroare', ToastrConfigs.danger);
      return;  
    }
    this.worksheetService.sendChatToTicket(ticket, event.message, this.userId, originalName, fileContent, notifyClient)
      .subscribe((response: any) => {
        if (!response.status){
          switch(Object.keys(response.error || {})[0]){
            case 'SizeZero': 
              this.toastrService.show('Fișier atașat este gol.', 'Mesaj ne trimis', ToastrConfigs.danger);
              break;
            case 'UploadFail':
              this.toastrService.show(
                'Fișier atașat nu a putut fi salvat in server.',
                'Mesaj ne trimis',
                ToastrConfigs.danger
              );
              break;
          }
          return;
        }
        else if (response.fileName && response.fileName !== '') {
          this.downloadMessageAttachment(response.fileName, (url: string, fileType: string) => {
            this.files = [{
              url: url, 
              type: originalType,
              icon: 'file-text-outline',
            }];
           
            this.addMessage(event.message, response.fileName, this.files, originalName);
          });
        }
        else {
          this.addMessage(event.message, '', []);
        }
        this.formGroup.controls.id.setValue(response?.id);

        if (!this.isTicketCreated) {
          this.isTicketCreated = true;
          this.formGroup.controls['department'].disable();
          this.formGroup.controls['severity'].disable();
          this.formGroup.controls['title'].disable();
          this.formGroup.controls['toUserId'].disable();
        }

        files?.shift();
        if (files?.length > 0) {
          const reader = new FileReader();
          reader.onload = () => {
            const fileContent = reader.result.toString().split(',')[1]; 
            this.sendChatToTicket(event, files, fileContent, false);
          };
          reader.readAsDataURL(files?.[0]);
        }
      });
  }

  getTicket() {
    this.isSpinnerActive = true;
    if (this.ticketObj?.id) {
      this.worksheetService.getTicketById(this.ticketObj?.id)
        .subscribe((response: any) => {
        
          this.ticket = response?.data;
          this.isTicketCreated = true;
          this.getTeams();
          this.loadMessages().then((messages) => {
            this.isSpinnerActive = false;
            this.messages = messages;
            this.cdr.detectChanges();
          });
       
        });
    } else {
      this.ticket = this.ticketObj;
      this.getTeams();
      this.loadMessages().then((messages) => {
        this.isSpinnerActive = false;
        this.messages = messages;
        this.cdr.detectChanges(); 
      });
    }
  }

  initForm(ticket) {
    const isConta = ticket?.category === 'CONTABILITATE' || !ticket?.category;
    this.formGroup = new FormGroup({
      id: new FormControl(ticket?.id),
      userId: new FormControl(ticket?.userId || this.userId),
      clientId: new FormControl(ticket?.clientId),
      issue: new FormControl(ticket?.issue),
      severity: new FormControl(ticket?.severity || null, Validators.required),
      response: new FormControl(ticket?.response),
      toUserId: new FormControl(ticket?.toUserId, isConta ? Validators.required : null),
      department: new FormControl(ticket?.category || null, Validators.required),
      title: new FormControl(
        ticket?.title || '',
        isConta ? [] : [Validators.required, Validators.maxLength(100)]
      ),
    });
    this.formGroup.controls['department'].valueChanges.subscribe((dept) => {
      if (dept !== 'CONTABILITATE') {
        this.formGroup.controls['toUserId'].setValue(dept);
        this.formGroup.controls['title'].setValidators([Validators.required, Validators.maxLength(100)]);
      } else {
        this.formGroup.controls['toUserId'].setValue(null);
        this.formGroup.controls['title'].clearValidators();
        this.formGroup.controls['title'].setValue('');
      }
      this.formGroup.controls['title'].updateValueAndValidity();
    });
  
    this.isPageLoaded = true;
  }


  closeModal(formData) {
    this.dismiss(formData);
  }

  getTeams() {
    combineLatest([
      this.store.select(getTeams),
      this.store.select(getUsers),
      this.store.select(getTeamByUserId(this.userId)),
      this.store.select(isUserConta3(this.userId)),
      this.store.select(isUserTeamLead(this.userId)),
      this.store.select(getUserTeamLeader(this.userId)),
      this.store.select(getConta3Users),
      this.store.select(getTeamLeads),
      this.store.select(getUsersThatCanSolveAllTickets),
      this.store.select(isJuridic(this.userId)),
      this.store.select(getJuridicUsers),
    ]).subscribe({
      next: ([ teams, users, userTeam, isConta3, isTeamLead, userTeamLeader, conta3Users, teamLeads, usersThatCanSolveAllTickets, isJuridic, juridicUsers ]) => {
        if(!teams || !userTeam) {
          return;
        }
        if (isTeamLead || this.userId === '52' || this.userId === '975' || this.userId === '946' || this.userId === '989') {
          conta3Users.forEach(u => u !== undefined && this.ticketSolver.push(u));
          userTeam.members.forEach(u => u !== undefined && this.ticketSolver.push(u));
        }
        if (!isTeamLead) {
          userTeamLeader.forEach(u => u !== undefined && this.ticketSolver.push(u));
        }
        if (isConta3) {
          teamLeads.forEach(u => u !== undefined && this.ticketSolver.push(u));
          teams.forEach(team => {
            if (team.isconta == '1') {
              team.members.forEach(conta1User => conta1User !== undefined && this.ticketSolver.push(conta1User))
            }
          })
        }
        if (isJuridic) {
          users.forEach(u => u !== undefined && this.ticketSolver.push(u));
        }
        usersThatCanSolveAllTickets?.forEach(u => u !== undefined && this.ticketSolver.push(u));
        juridicUsers.forEach((u) => u !== undefined && this.ticketSolver.push(u));
        if(isTeamLead) {
          teamLeads.forEach((u) => u !== undefined && this.ticketSolver.push(u));
        }
        teams.forEach(team => {
          if (team.isconta == '1') {
            if (team.members.some(member => member?.user_id == this.userId)) {
              this.coordinatorId = team?.lead;
            }
          }
        });

        this.ticketSolver = _.uniqBy(this.ticketSolver, 'user_id');
        this.ticketSolver = this.ticketSolver.filter((user) => user !== undefined);
        this.initForm(this.ticket);
      }
    });
  }

  private loadMessages(): Promise<any[]> {
    const chatPromises = this.ticket?.chats?.map(chat => {
      return new Promise((resolve) => {
        if (chat.filename) {
            let fileIcon = 'attach-outline';
            if (chat.filename.split('.')?.[1] === 'png' || chat.filename.split('.')?.[1] === 'jpeg' || chat.filename.split('.')?.[1] === 'jpg') {
              fileIcon = 'image-outline';
            } else if (chat.filename.split('.')?.[1].toLowerCase() === 'pdf') {
              fileIcon = 'file-outline';
            } else if (chat.filename.split('.')?.[1].toLowerCase() === 'mp4') {
              fileIcon = 'film-outline';
            } else if (chat.filename.split('.')?.[1].toLowerCase() === 'xls' || chat.filename.split('.')?.[1].toLowerCase() === 'xlsx') {
              fileIcon = 'layout-outline';
            } else if (chat.filename.split('.')?.[1].toLowerCase() === 'txt' || chat.filename.split('.')?.[1].toLowerCase() === 'doc' || chat.filename.split('.')?.[1].toLowerCase() === 'docx') {
              fileIcon = 'file-text-outline';
            } else if (chat.filename.split('.')?.[1].toLowerCase() === 'rar' || chat.filename.split('.')?.[1].toLowerCase() === 'zip') {
              fileIcon = 'briefcase-outline';
            }


            this.files = [{
              url: '',
              type: '',
              icon: fileIcon,
            }];
            resolve({
              type: 'asconFile',
              message: chat.message && chat.message !== '' ? chat.message : chat.filename,
              date: moment(parseFloat(chat.date)).toDate(),
              reply: chat.userId === this.userId,
              user: {
                name: `${chat.user_firstname} ${chat.user_lastname}`,
                avatar: '',
              },
              fileName: chat.filename || '',
              files: this.files,
            });
          } else {
            resolve({
            type: 'text',
            message: chat.message,
            date: moment(parseFloat(chat.date)).toDate(),
            reply: chat.userId === this.userId,
            user: {
              name: `${chat.user_firstname} ${chat.user_lastname}`,
              avatar: '',
            },
            fileName: '',
            files: [],
          });
        }
      });
    });

    return Promise.all(chatPromises || []);
  }
  
  downloadMessageAttachment(fileName: string, callback: (url: any, fileType: string) => void): void {
    this.worksheetService.downloadMessageAttachment(fileName).subscribe(
      (response: any) => {
        const contentType = response.headers.get('Content-Type');
        const blob = new Blob([response.body], { type: contentType });
        const url = window.URL.createObjectURL(blob);
  
        // const safeUrl = this.sanitizer.bypassSecurityTrustUrl(url);
  
        callback(url, contentType);
      },
      error => {
        console.error('Download failed', error);
      }
    );
  }

  markAsRepetitiveIssue(issue: any) {
    this.dialogService
      .open(ConfirmActionModalComponent, {
        context: {
          title: 'ATENȚIE',
          description: `Ești sigur că dorești să marchezi întrebarea ca repetitivă?`,
          withConsent: false,
        }
      })
      .onClose.subscribe((res: any) => {
      if (res) {
        this.worksheetService.setRepetitiveIssue(issue)
          .subscribe((isRepetitiveRes: any) => {
            if (isRepetitiveRes.status){
              this.ticketObj.repetitiveIssue = 'true';
            }
          });
      }
    });
  }

  markAsAndweredTicketProcessing(issue: any) {
    this.dialogService
      .open(ConfirmActionModalComponent, {
        context: {
          title: 'ATENȚIE',
          description: `Ești sigur că dorești să marchezi întrebarea ca răspuns dat, ticket în rezolvare?`,
          withConsent: false,
        }
      })
      .onClose.subscribe((res: any) => {
      if (res) {
        this.worksheetService.setAnsweredTicketProcessing(issue)
          .subscribe((isAnsweredTicketProcessingRes: any) => {
            if (isAnsweredTicketProcessingRes.status){
              this.ticketObj.status = 'solving';
            }
          });
      }
    });
  }
  
  download(filename) {
    this.downloadMessageAttachment(filename, (url, type) => {
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    })
  }

  focusChatInput(){
    this.chatForm?.nativeElement?.firstElementChild?.firstElementChild.focus();
  }
}
